var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-box"},[_c('i',{staticClass:"iconfont icon-yichang"}),_c('div',{staticStyle:{"margin-top":"2rem"}},[_vm._v(_vm._s(_vm.info)+"异常，已停止访问")]),_c('div',{staticStyle:{"margin-top":"2rem","font-size":"0.7rem"}},[_vm._v("请在"+_vm._s(_vm.position)+"中打开 或 重新访问")])])
}
var staticRenderFns = []

export { render, staticRenderFns }